import { createWebHistory, createRouter } from "vue-router";
import { getAuth } from "firebase/auth";
const auth = getAuth();

// MAGNET
import Magnet from "@/views/magnet/magnetPage.vue";

// SIGN IN // SIGN UP
import Access from "@/views/access/AccessPage";
import SignupForm from "@/views/access/SignupForm.vue";
import Verify from "@/views/access/AccessVerify";
import Join from "@/views/access/AccessJoin";
import AddWorkspace from "@/views/access/AccessWorkspace.vue";
import Password from "@/views/access/AccessPassword.vue";
import PaymentSuccess from "@/views/access/PaymentSuccess.vue";
import OnboardingPage from "@/views/access/OnboardingPage.vue";

// DEMO
import demo from "@/views/demo/social_demo.vue";
import demo_posts from "@/views/demo/demo_posts.vue";
import demo_offer from "@/views/demo/demo_offer.vue";
import demo_intro from "@/views/demo/demo_intro.vue";
import demo_ideas from "@/views/demo/demo_ideas.vue";
import demo_variants from "@/views/demo/demo_variants.vue";
import demo_scheduling from "@/views/demo/demo_scheduling.vue";

// WORKSPACE
import workspace from "@/views/settings/WorkspacePage.vue";
import settings from "@/views/settings/SettingsPage.vue";
import profile from "@/views/settings/SettingsProfile.vue";
import subscription from "@/views/settings/SettingsSubscription.vue";
import brand from "@/views/settings/SettingsBrand.vue";
// import users from "@/views/settings/SettingsUsers.vue";
// import workspace_profile from "@/views/settings/SettingsWorkspace.vue";
// import referrals from "@/views/settings/SettingsReferrals.vue";
// import stixAI from "@/views/settings/SettingsStixAI.vue";
// import accounts from "@/views/settings/SettingsAccounts.vue";
// import workspaces from "@/views/settings/SettingsWorkspaces.vue";
import settings_roadmap from "@/views/settings/SettingsRoadmap.vue";
// SOCIAL
import social_home from "@/views/home/social_home.vue";
import social_post from "@/views/post/social_post.vue";
import social_feed from "@/views/feed/social_feed.vue";
import social_schedule from "@/views/schedule/social_schedule.vue";
import social_categories from "@/views/categories/SocialCategories.vue";
import social_inbox from "@/views/inbox/social_inbox.vue";
import social_calendar from "@/views/calendar/social_calendar.vue";
import social_template from "@/views/template/social_template.vue";
import social_chat from "@/views/chat/social_chat.vue";
import social_category from "@/views/categories/SocialCategory.vue";

// LIBRARY
import library_knowledge from "@/views/library/knowledge/index.vue";
import library_posts from "@/views/library/library_posts.vue";
// import library_templates from "@/views/library/templates/library_templates.vue";
// import library_ideas from "@/views/library/ideas/library_ideas.vue";
import library_media from "@/views/library/media/library_media.vue";
// import library_structures from "@/views/library/structures/library_structures.vue";

// ADMIN
import social_admin from "@/views/admin/SocialAdmin.vue";
import admin_users from "@/views/admin/users/AdminUsers.vue";
import admin_workspaces from "@/views/admin/workspaces/AdminWorkspaces.vue";
import admin_notifications from "@/views/admin/notifications/AdminNotifications.vue";
import admin_calendar from "@/views/admin/calendar/AdminCalendar.vue";
import admin_posts from "@/views/admin/posts/AdminPosts.vue";
import admin_settings from "@/views/admin/settings/AdminSettings.vue";
import admin_backlog from "@/views/admin/backlog/AdminBacklog.vue";
import admin_emails from "@/views/admin/emails/AdminEmails.vue";
import admin_dashboard from "@/views/admin/dashboard/AdminDashboard.vue";
import admin_waiting from "@/views/admin/waitinglist/AdminWaiting.vue";
import admin_support from "@/views/admin/support/AdminSupport.vue";

// Wizards
import activationWizard from "@/views/wizards/activationWizard.vue";

// PUBLIC
import public_view from "@/views/public/public_view.vue";
import public_backlog from "@/views/public/backlog/public_backlog.vue";

// SUPPORT
import support from "@/views/support/SupportPage.vue";

// ARTICLES
import inspirationLibrary from "@/views/inspiration/inspirationLibrary.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: social_home,
    redirect: "/library",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/support",
    name: "Support",
    component: support,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/access",
    name: "Access",
    component: Access,
    meta: {
      noNav: true,
    },
  },
  {
    path: "/payment-success",
    name: "Payment Success",
    component: PaymentSuccess,
    meta: {
      noNav: true,
    },
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: OnboardingPage,
    meta: {
      noNav: false,
    },
  },
  {
    path: "/password",
    name: "Access Password",
    component: Password,
    meta: {
      noNav: true,
      requiresAuth: false,
    },
  },
  {
    path: "/magnet",
    name: "Magnet",
    component: Magnet,
    meta: {
      noNav: true,
      requiresAuth: false,
    },
  },
  {
    path: "/demo",
    name: "Demo",
    component: demo,
    redirect: "/demo/posts",
    meta: {
      requiresAuth: false,
      noNav: true,
    },
    children: [
      {
        path: "/demo/posts",
        name: "Posts (demo)",
        component: demo_posts,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
      {
        path: "/demo/offer",
        name: "Offer (demo)",
        component: demo_offer,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
      {
        path: "/demo/intro",
        name: "Intro (demo)",
        component: demo_intro,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
      {
        path: "/demo/ideas",
        name: "Generate ideas (demo)",
        component: demo_ideas,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
      {
        path: "/demo/variants",
        name: "Generate variants (demo)",
        component: demo_variants,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
      {
        path: "/demo/scheduling",
        name: "Scheduling (demo)",
        component: demo_scheduling,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
    ],
  },
  {
    path: "/verify",
    name: "Verify",
    component: Verify,
    meta: {
      noNav: true,
      requiresAuth: false,
    },
  },

  {
    path: "/join",
    name: "Join",
    component: Join,
    meta: {
      noNav: true,
    },
  },
  {
    path: "/create-workspace",
    name: "Create workspace",
    component: AddWorkspace,
    meta: {
      noNav: true,
      requiresAuth: true,
    },
  },
  {
    path: "/waiting-list",
    name: "Waiting List Form",
    component: SignupForm,
    meta: {
      noNav: true,
      requiresAuth: false,
    },
  },
  {
    path: "/workspace",
    name: "Workspace",
    component: workspace,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/library",
    name: "Library",
    component: library_posts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/library/knowledge",
    name: "Knowledge",
    component: library_knowledge,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/media",
    name: "Media",
    component: library_media,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inspiration",
    name: "Inspiration",
    component: inspirationLibrary,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/public",
    name: "Public",
    component: public_view,
    redirect: "/public/backlog",
    meta: {
      requiresAuth: false,
      noNav: true,
    },
    children: [
      {
        path: "/public/backlog",
        name: "Public Backlog",
        component: public_backlog,
        meta: {
          requiresAuth: false,
          noNav: true,
        },
      },
    ],
  },
  {
    path: "/admin",
    name: "Admin",
    component: social_admin,
    redirect: "/admin/dashboard",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/admin/dashboard",
        name: "Admin - Dashboard",
        component: admin_dashboard,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/users",
        name: "Admin - Users",
        component: admin_users,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/workspaces",
        name: "Admin - Workspaces",
        component: admin_workspaces,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/notifications",
        name: "Admin - Notifications",
        component: admin_notifications,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/calendar",
        name: "Admin - Calendar",
        component: admin_calendar,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/posts",
        name: "Admin - Posts",
        component: admin_posts,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/settings",
        name: "Admin - Settings",
        component: admin_settings,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/backlog",
        name: "Admin - Backlog",
        component: admin_backlog,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/emails",
        name: "Admin - Emails",
        component: admin_emails,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/waiting-list",
        name: "Admin - Waiting List",
        component: admin_waiting,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/support",
        name: "Admin - Support",
        component: admin_support,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/brand",
    name: "Brand",
    component: brand,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: subscription,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/roadmap",
    name: "Roadmap",
    component: settings_roadmap,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: social_calendar,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/post",
    name: "Post",
    component: social_post,
    props: true,
    meta: {
      requiresAuth: true,
      noHeader: true,
    },
  },
  {
    path: "/feed",
    name: "Feed",
    component: social_feed,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/categories",
    name: "Categories",
    component: social_categories,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/categories/:id",
    name: "Category",
    component: social_category,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/chat",
    name: "Chat",
    component: social_chat,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/template/:id",
    name: "Edit template",
    component: social_template,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schedule",
    name: "Schedule",
    component: social_schedule,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/inbox",
    name: "Inbox",
    component: social_inbox,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/get-started",
    name: "Get started",
    component: activationWizard,
    meta: {
      requiresAuth: true,
      noHeader: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);

  if (requiresAuth && !auth.currentUser) {
    next("/access");
  } else {
    next();
  }
});

router.afterEach((to) => {
  // Track page views for analytics
  if (to.name && auth.currentUser) {
    import("@/utils/analytics").then(({ trackPageView }) => {
      trackPageView(to.name, {
        path: to.path,
        userId: auth.currentUser.uid,
        timestamp: new Date().toISOString(),
      });
    });
  }
});

export default router;
